// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductReport":"eo_a bhh_a bhh_x bhh_j bhh_u bhh_bc bhh_qj bhh_vt"};